import { ChevronLeft } from 'lucide-react';
import React from 'react';
import { generatePath, useNavigate } from 'react-router';
import { Button, TypographyH3 } from '@/Components/shadcn';
import CandidateFavorite from './Components/CandidateFavorite';
import { useCandidatesResultsContext } from '../../Contexts/CandidateResultsContext';
import RoutePath from '@/Routing/RoutePath';
import useCompanyId from '@/Hooks/UseCompanyId';
import { useRecruitmentId } from '@/Hooks';

function HeaderInfo(): React.JSX.Element {
    const navigate = useNavigate();
    const companyId = useCompanyId();
    const assessmentId = useRecruitmentId();
    const { results } = useCandidatesResultsContext();
    const { candidateFirstName, candidateLastName } = results;
    const candidateOverviewPath = generatePath(RoutePath.CandidatesOverview, { companyId, assessmentId });

    return (
        <div className="flex flex-row items-center justify-start gap-2">
            <Button
                type="button"
                variant="ghost"
                size="icon"
                onClick={() => navigate(candidateOverviewPath)}
                aria-label="Back"
            >
                <ChevronLeft className="size-5" />
            </Button>
            <CandidateFavorite />
            <TypographyH3 className="text-foreground">
                {candidateFirstName} {candidateLastName}
            </TypographyH3>
        </div>
    );
}

export default HeaderInfo;
